const initialState = { 
  userRole: "admin", 
  // 새로고침 시 localStorage에서 데이터를 복구, 없으면 빈 배열
  allowedPaths: JSON.parse(localStorage.getItem("allowedPaths")) || [] 
};

export const login = (state = initialState , action) => {
  switch (action.type) {
	case "SET_ALLOWED_PATHS":
	  // 리듀서에서 상태를 업데이트할 때 localStorage에도 함께 저장하여 동기화합니다.
	  localStorage.setItem("allowedPaths", JSON.stringify(action.payload));
	  return { ...state, allowedPaths: action.payload };
    case "LOGIN_WITH_EMAIL": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_FB": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_TWITTER": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_GOOGLE": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_GITHUB": {
      return { ...state, values: action.payload };
    }
    case "LOGIN_WITH_JWT": {
      return { ...state, values: action.payload };
    }
    case "LOGOUT_WITH_JWT": {
      return { ...state, values: action.payload };
    }
    case "LOGOUT_WITH_FIREBASE": {
      return { ...state, values: action.payload };
    }
    case "CHANGE_ROLE": {
      return { ...state, userRole: action.userRole };
    }
    default: {
      return state;
    }
  }
};
